// extracted by extract-css-chunks-webpack-plugin
module.exports = {"pathFill":"_clMs","dash":"-GTen"};